var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":_vm.$options.name}},[_c('a-restaurant-sales',{ref:"a-restaurant-sales",attrs:{"tab_view":_vm.tab_view}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }